/* spec: specs/tabbed-collection.md */

class TabbedCollectionComponent extends HTMLElement {
  constructor() {
    super();

    this.tablist = this.querySelector('[role="tablist"]');
    if (!this.tablist) return;

    this.tabs = Array.from(this.querySelectorAll('.tabbed-collection__tab'));
    this.panels = Array.from(this.querySelectorAll('.tabbed-collection__panel'));

    this.panels.forEach((panel, i) => {
      if (i !== 0) panel.classList.add('tabbed-collection__panel--hidden');
      panel.setAttribute('aria-hidden', i !== 0 ? 'true' : 'false');
    });

    this.tablist.addEventListener('click', (e) => {
      const tab = e.target.closest('.tabbed-collection__tab');
      if (!tab) return;
      this._activateTab(tab);
    });
  }

  _activateTab(activeTab) {
    const panelId = activeTab.dataset.panel;

    this.panels.forEach((panel) => {
      panel.classList.add('tabbed-collection__panel--hidden');
      panel.setAttribute('aria-hidden', 'true');
    });

    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false');
      tab.classList.remove('tabbed-collection__tab--active');
    });

    const targetPanel = this.querySelector('#' + panelId);
    if (targetPanel) {
      targetPanel.classList.remove('tabbed-collection__panel--hidden');
      targetPanel.setAttribute('aria-hidden', 'false');
    }

    activeTab.setAttribute('aria-selected', 'true');
    activeTab.classList.add('tabbed-collection__tab--active');
  }
}

customElements.define('tabbed-collection-component', TabbedCollectionComponent);
